import { uniqBy } from 'lodash/array';
import { sortBy } from 'lodash/collection';

export function mapStudySitesToSsuOptions(studySites) {
  return studySites.map(toSsuOption);
}

export function getStudies(studySites) {
  return sortBy(uniqBy(studySites.map(({ study }) => study).filter(Boolean), 'uniqueIdentifier'), 'studyName');
}

export function getSites(studySites, selectedStudy) {
  return sortBy(
    uniqBy(
      studySites
        .filter(({ studyIdentifier }) => !selectedStudy || selectedStudy.uniqueIdentifier === studyIdentifier)
        .map(({ site }) => site)
        .filter(Boolean),
      'uniqueIdentifier'
    ),
    'siteName'
  );
}

export function buildPushPayload(selectedPatientIds, selectedStudy, selectedSite, studySites) {
  return {
    patientIds: selectedPatientIds,
    ssuId: studySites.find(
      ({ studyIdentifier, siteIdentifier }) =>
        studyIdentifier === selectedStudy.uniqueIdentifier && siteIdentifier === selectedSite.uniqueIdentifier
    )?.uniqueIdentifier
  };
}

export function studyFilterFunction(option, index, collection, searchString) {
  return `${option?.projectCode || ''} ${option?.studyName || ''}`.toLowerCase().includes(searchString);
}

function toSsuOption(studySite) {
  return {
    uniqueIdentifier: studySite.id,
    studyIdentifier: studySite.study?.id,
    siteIdentifier: studySite.site?.id,
    study: studySite.study
      ? {
          uniqueIdentifier: studySite.study.id,
          studyName: studySite.study.name,
          projectCode: studySite.study.projectCode
        }
      : null,
    site: studySite.site
      ? {
          uniqueIdentifier: studySite.site.id,
          siteName: studySite.site.name
        }
      : null
  };
}
